import { render, staticRenderFns } from "./OrderSuccesful.vue?vue&type=template&id=f34be564&"
import script from "./OrderSuccesful.vue?vue&type=script&lang=js&"
export * from "./OrderSuccesful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports